// extracted by mini-css-extract-plugin
module.exports = {"NoResult":"noResult_NoResult__YLreA","title":"noResult_title__wReSU","txt":"noResult_txt__wNxKU","confirm":"noResult_confirm__17A5O"};